export default __webpack_public_path__ + "/images/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-700.svg";